import React from "react";

type HeaderProps = React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode;
  className?: string;
};

export function Header1({ children, className = "", ...props }: HeaderProps) {
  return (
    <h1 className={`text-4xl font-bold ${className}`} {...props}>
      {children}
    </h1>
  );
}

export function Header2({ children, className = "", ...props }: HeaderProps) {
  return (
    <h2 className={`text-3xl font-semibold ${className}`} {...props}>
      {children}
    </h2>
  );
}

export function Header3({ children, className = "", ...props }: HeaderProps) {
  return (
    <h3 className={`text-2xl font-semibold ${className}`} {...props}>
      {children}
    </h3>
  );
}

export function Header4({ children, className = "", ...props }: HeaderProps) {
  return (
    <h4 className={`text-xl font-medium ${className}`} {...props}>
      {children}
    </h4>
  );
}

export function Header5({ children, className = "", ...props }: HeaderProps) {
  return (
    <h5 className={`text-lg font-medium ${className}`} {...props}>
      {children}
    </h5>
  );
}

export function Header6({ children, className = "", ...props }: HeaderProps) {
  return (
    <h6 className={`text-base font-normal ${className}`} {...props}>
      {children}
    </h6>
  );
}
